import SearchButton from './search-button'

export default SearchButton
